
export function Community() {
    return (
        <>
            <SEO title="Community - PostMgr" description="Join the PostMgr community of social media marketers" url="https://postmgr.com/community" />
            {/* Similar structure... */}
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">Community</h1>
                    <p className="text-xl text-gray-600">Coming soon...</p>
                </div>
            </div>
        </>
    );
}

export default Community;